<template>
  <div class="page">
    <div id="container" />
  </div>
</template>

<script>
import { Graph } from '@antv/x6'

export default {
  name: 'Workflow',
  props: {
    contract: Object,
    currentStep: Object,
    contractSteps: Array,
  },
  mounted() {
    console.log(this.contract, this.contractSteps, this.currentStep);
    this.initGraph()
  },

  methods: {
    initGraph() {
      const graph = new Graph({
        container: document.getElementById('container'),

        width: '100%',
        height: '100%',

        grid: {
          size: 10,
          visible: true,
        },

        panning: true,

        mousewheel: {
          enabled: true,
          modifiers: ['ctrl'],
          minScale: 0.5,
          maxScale: 2,
        },

        interacting: false,
      })

      // =========================
      // NODE POSITIONS
      // =========================

      const nodes = [
        {
          id: 'start',
          x: 510,
          y: 40,
          width: 80,
          height: 80,
          shape: 'circle',
          label: 'Bắt đầu',
          fill: '#84cc16',
        },
        ...this.contractSteps.map((step, index) => ({
          id: step.id,
          x: 420,
          y: 40 + 150 * (index + 1),
          width: 260,
          height: 60,
          label: step.name,
          fill: '#00c853',
          stroke: this.currentStep?.id === step.id ? '#ff0000' : null,
        })),
        {
          id: 'end',
          x: 510,
          y: 40 + 150 * (this.contractSteps.length + 1),
          width: 80,
          height: 80,
          shape: 'circle',
          label: 'Kết thúc',
          fill: '#ff5722',
        },
      ]

      // =========================
      // RENDER NODE
      // =========================

      nodes.forEach((node) => {
        graph.addNode({
          ...node,

          attrs: {
            body: {
              fill: node.fill,

              stroke: node.stroke || 'transparent',

              strokeWidth: node.stroke ? 3 : 1,

              rx: node.shape === 'circle' ? 40 : 10,
              ry: node.shape === 'circle' ? 40 : 10,
            },

            label: {
              text: node.label,
              fill: '#fff',
              fontSize: 14,
              fontWeight: 700,
            },
          },
        })
      })

      // =========================
      // EDGE HELPER
      // =========================

      const addEdge = ({
        source,
        target,
        label,
        color = '#999',
        vertices = [],
      }) => {
        graph.addEdge({
          source,
          target,

          vertices,

          router: {
            name: 'orth',
          },

          connector: {
            name: 'rounded',
            args: {
              radius: 12,
            },
          },

          labels: label
            ? [
                {
                  position: 0.5,

                  attrs: {
                    label: {
                      text: label,
                      fill: color,
                      fontSize: 13,
                      fontWeight: 600,
                    },
                  },
                },
              ]
            : [],

          attrs: {
            line: {
              stroke: color,
              strokeWidth: 2,

              targetMarker: {
                name: 'classic',
                size: 8,
              },
            },
          },
        })
      }

      // =========================
      // MAIN FLOW
      // =========================

      this.contractSteps.forEach((step, index) => {
        if (index === 0) {
          addEdge({
            source: 'start',
            target: step.id,
          })
        }
        if (index < this.contractSteps.length - 1) {
          const actions = step.actions;
          actions.forEach((action, j) => {
            if (j === 0) {
              addEdge({
                source: step.id,
                target: this.contractSteps[index + 1].id,
                label: action.translation.name,
              })
            }
            if (action.extra_data.action_id) {
              addEdge({
                source: step.id,
                target: this.contractSteps[index - 1].id,
                label: action.translation.name,
                color: '#ff4d4f',
                vertices: [
                  { x: 540 + 120 * (index + 1), y: 40 + 150 * (index + 1) },
                  { x: 540 + 120 * (index + 1), y: 40 + 150 * (index) },
                ],
              })
            }
            if (action.extra_data.to_state.includes('rejected')) {
              addEdge({
                source: step.id,
                target: 'end',
                label: action.translation.name,
                color: '#fa8c16',
                vertices: [
                  { x: 600 + 120 * (index + 1), y: 125 + 150 * (index + 1) },
                  { x: 600 + 120 * (index + 1), y: 40 + 150 * (this.contractSteps.length + 1) },
                ],
              })
            }
          })
        }
        if (index === this.contractSteps.length - 1) {
          addEdge({
            source: step.id,
            target: 'end',
          })
        }
      })
      graph.centerContent()
    }
  }
}
</script>

<style scoped>
.page {
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

#container {
  width: 100%;
  height: 100%;
}
</style>
